/// <reference types="./uniqueIndexGetValues.d.ts" />
import { buildSqliteSqlQuery, } from '@dossierhq/database-adapter';
import { queryMany } from '../QueryFunctions.js';
export async function adminEntityUniqueIndexGetValues(database, context, entity) {
    const result = await queryMany(database, context, buildSqliteSqlQuery(({ sql }) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        sql `SELECT index_name, value, latest, published FROM unique_index_values WHERE entities_id = ${entity.entityInternalId}`;
    }));
    if (result.isError())
        return result;
    return result.map((rows) => rows.map((row) => ({
        index: row.index_name,
        value: row.value,
        latest: !!row.latest,
        published: !!row.published,
    })));
}
//# sourceMappingURL=uniqueIndexGetValues.js.map